
export const validateEmail = (val: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
export const validatePhone = (val: string) =>
    /^\d{3}[-.\s]?\d{3}[-.\s]?\d{4}$/.test(val) ||
    /^\(\d{3}\)\s?\d{3}-\d{4}$/.test(val) ||
    val.startsWith('+');

/**
 * Normalizes a US phone number to (XXX) XXX-XXXX format.
 * - Strips all non-digit characters and formats 10-digit results.
 * - Strips leading "1" from 11-digit inputs before formatting.
 * - Returns international numbers (starting with +) and unrecognizable inputs unchanged.
 *
 * NOTE: A duplicate of this function exists in functions/src/roster-sync.ts
 *       for the Cloud Functions bundle. Keep both copies in sync.
 */
export function formatPhoneNumber(raw: string): string {
    if (!raw) return raw;
    if (raw.startsWith('+')) return raw;

    const digits = raw.replace(/\D/g, '');

    if (digits.length === 10) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    if (digits.length === 11 && digits.startsWith('1')) {
        return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
    }

    return raw;
}

export const getValidationClass = (val: string, type: 'email' | 'phone') => {
    if (!val) return '';
    const isValid = type === 'email' ? validateEmail(val) : validatePhone(val);
    return isValid ? '' : ' underline decoration-dotted decoration-red-500';
};














